import { Badge } from '@/components/ui/badge'
import { InfoIcon } from 'lucide-react'

interface DraftBadgeProps {
  className?: string
  showIcon?: boolean
}

export function DraftBadge({ className, showIcon = false }: DraftBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={`bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-900 dark:text-yellow-200 dark:border-yellow-700 ${className}`}
      title="Dados mockados - Em desenvolvimento"
    >
      {showIcon && <InfoIcon className="h-3 w-3 mr-1" />}
      DRAFT
    </Badge>
  )
}
